import React, {
  Component
} from 'react';
const $ = window.$;
const Fr= window.Fr;
let  timerinc;
export default class RecordPlayer extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            timer: "00:00:00",
            displayareas:'1',
            audiosrc:'',
            discardvoice:false,
        };
    }

    formatTime(seconds) {
        let hours = Math.floor(seconds / 60);
        hours = (hours >= 10) ? hours : "0" + hours;
        let minutes = Math.floor(seconds / 60);
        minutes = (minutes >= 10) ? minutes : "0" + minutes;
        seconds = Math.floor(seconds % 60);
        seconds = (seconds >= 10) ? seconds : "0" + seconds;
        return  hours + ":" + minutes + ":" + seconds;
    }
    recordoption_fn () {
       // console.log("recordoption_fn");
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);

        let thisref=this;
        thisref.setState({timer: "00:00:00",discardvoice:false});
      
       Fr.voice.record($("#record").is(":checked"), function()
        {
            // recordid.hide();    
            // pauseid.show();
            thisref.setState({displayareas: '2'});
            setTimeout(() => {
             timerinc = setInterval(function(){
               
              
                //console.log("===loop 1==");
                let time_shown = thisref.state.timer;
                let time_chunks = time_shown.split(":");
                let hour, mins, secs;
        
                
                hour = Number(time_chunks[0]);
                mins = Number(time_chunks[1]);
                secs = Number(time_chunks[2]);
                secs++;
                if (secs == 60) {
                    secs = 0;
                    mins = mins + 1;
                }
                if (mins == 60) {
                    mins = 0;
                    hour = hour + 1;
                }
                hour = hour + '';
                if (hour < 10) {
                    hour = "0" + hour;
                }
                mins = mins + '';
                if (mins < 10) {
                    mins = "0" + mins;
                }
                secs = secs + '';
                if (secs < 10) {
                    secs = "0" + secs;
                }
                
                thisref.setState({
                    timer: hour + ":" + mins + ":" + secs,
                });

            }, 1000);
            },1500);
         
           
        });    

    }

    recordpauseoption_fn(){
       // console.log("recordpauseoption_fn");
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);

        Fr.voice.pause();
        this.setState({timer: "00:00:00", displayareas:'3',});
    }


    recordplayoption_fn(){
        //console.log("recordplayoption_fn");
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);
       
        let thisref=this;
        

        Fr.voice.export(function(url)
        {
            thisref.setState({
                audiosrc:url, displayareas:'5',discardvoice:true
            });
            $("#audio").attr("src", url);
           
            
        }, "URL");
        setTimeout(() => {
            if(typeof timerinc!=='undefined')
            clearInterval(timerinc);
            $("#audio")[0].play();
            timerinc = setInterval(function(){ 
               // console.log("===loop 2==");
                let aud=$("#audio")[0];
                let timing=thisref.formatTime(aud.currentTime);
                
                if(thisref.formatTime(aud.duration)<=timing)
               {
                clearInterval(timerinc);
                thisref.setState({displayareas:'3',timer: "00:00:00",});
               }
                else
                thisref.setState({timer: timing});
                
            }, 500);
        },500);
        
       

    }
    recordplayagain_fn(){
        //console.log("recordplayagain_fn");
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);
       

        let thisref=this;
        thisref.setState({
           displayareas:'5',discardvoice:true
        });
        setTimeout(() => {
            if(typeof timerinc!=='undefined')
            clearInterval(timerinc);
            $("#audio")[0].play();
            timerinc = setInterval(function(){ 
                //console.log("===loop 3==");
                let aud=$("#audio")[0];
                let timing=thisref.formatTime(aud.currentTime);
                
                if(thisref.formatTime(aud.duration)<=timing)
               {
                clearInterval(timerinc);
                thisref.setState({displayareas:'3',timer: "00:00:00",});
               }
                else
                thisref.setState({timer: timing});
                
            }, 500);
        },500);

    }
    recordplaypause_fn()
    {
        //console.log("recordplaypause_fn");
        let aud=$("#audio")[0];
        aud.pause();
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);
        this.setState({displayareas:'4',discardvoice:true});
        if(this.formatTime(aud.duration)<=this.formatTime(aud.currentTime))
        {
            this.setState({timer: "00:00:00"});
        }
    }
    recorddiscard_fn(){
        //console.log("recorddiscard_fn");
        if(typeof timerinc!=='undefined')
        clearInterval(timerinc);
        Fr.voice.stop();
        if($("#audio")[0])
        $("#audio")[0].pause();
        this.setState({discardvoice: false,audiosrc:'',displayareas:'1',timer: "00:00:00",});
    }   

    



  render() {
      let displayareas=this.state.displayareas;
      let discardvoice=this.state.discardvoice;
    return (
    //  <div data-type="mp3" className="recordPlayer">
    //   <ul className="btn-ul">

    //    <li>
    //    <a id="record" className="button recordButton" style={{borderRadius: "25px",padding:"10px 40px",marginLeft:"50px"}}><i className="fa fa-microphone"></i>Record</a>
    //    </li>

    //    <li><a id="pause" className="button ply-btn " style={{display:"none",borderRadius: "25px",padding:"10px 40px"}}> <i className="fa fa-pause"></i> Pause </a> <a id="play" className="button ply-btn" style={{display:"none",borderRadius:"25px",padding:"10px 40px"}} > <i className=" fa fa-play"></i>Play</a></li>
    //    <li className="widht-100">
    //    <audio className="audio-btm" id="audio" controlsList="nodownload" controls></audio>

    //    </li>
    //   </ul>
    //   </div>

    <div>
      {/* <div style={{'clear':'both'}}></div> */}
      <div className='wav-tst'>
      <div data-type="wav" className="wave-new">
						<h2 id="audiotimedur">{ this.state.timer }</h2>
							<ul className="btn-ul">

							<li><a className="button recordButton" style={{ display:(displayareas=='1')? '':'none'}} id="record" onClick={(e) => this.recordoption_fn()}><i className="fa fa-microphone"></i><h2 className="caption">Record Audio</h2></a></li>
							<li><a id="pause" style={{ 'display':(displayareas=='2')? '':'none'}} onClick={(e) => this.recordpauseoption_fn()}> <i className="fa fa-pause"></i><h2 className="caption">Stop Recording</h2></a></li>
							<li><a style={{ 'display':(displayareas=='3')? '':'none'}} id="play" onClick={(e) => this.recordplayoption_fn()}><i className="fa fa-play"></i><h2 className="caption">Play Audio</h2></a></li>
							<li><a className="playagain" style={{ display:(displayareas=='4')? '':'none'}} id="playagain" onClick={(e) => this.recordplayagain_fn()}><i className="fa fa-play"></i><h2 className="caption">Play Audio</h2></a></li>
							<li><a className="playpause" onClick={(e) => this.recordplaypause_fn()} style={{ display:(displayareas=='5')? '':'none'}} id="playpause"><i className="fa fa-pause"></i><h2 className="caption">Pause Audio</h2></a></li>
							</ul>
							<audio controls="" id="audio" style={{display:'none',position:'relative'}} src={this.state.audiosrc}></audio>
              <div style={{'clear':'both'}}></div>
						<div className="btn-container">
						
							<a id="discardvoice" onClick={(e) => this.recorddiscard_fn()} style={{display:(discardvoice)? '':'none'}}>Discard</a>
						</div>
						
					</div>
          </div>
          {/* <div style={{'clear':'both'}}></div> */}
    </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/grid_partials/RecordPlayer.js